export default __webpack_public_path__ + "static/media/icon_financeiro.253686f9.svg";